module.exports = __webpack_public_path__ + "static/img/LD_CN-100C.6075f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/LD_CN-100C.png
// module id = iP34
// module chunks = 38